import { useState, useEffect } from 'react';
import { ToastCtx } from './_barrel.js';


        function ToastProvider({ children }) {
            const [toast, setToast] = useState(null);
            useEffect(() => {
                if (!toast) return;
                const t = setTimeout(() => setToast(null), 4500);
                return () => clearTimeout(t);
            }, [toast]);
            const notify = (message, kind = 'info') => setToast({ message, kind });
            return (
                <ToastCtx.Provider value={notify}>
                    {children}
                    {toast && (
                        <div className={`toast ${toast.kind}`}>
                            <div className="font-mono text-xs uppercase tracking-widest text-muted mb-1">
                                {toast.kind === 'error' ? 'Error' : 'Notice'}
                            </div>
                            <div>{toast.message}</div>
                        </div>
                    )}
                </ToastCtx.Provider>
            );
        }

export { ToastProvider };
